import { FF2Step, FormData } from "../types";
import { isEndDateLessThanXDays } from "../../../../utils/isEndDateLessThanXDays";
import { AdditionalBorrowing } from "../../../../types/common";

export const handleRemoStep = (formData: FormData) => {
  let nextStep;

  // Turn away users borrowing less than our minimum
  const cleanedAmount = formData.balance!.replace(",", "");
  const balance = parseInt(cleanedAmount, 10);
  if (balance < MIN_MORTGAGE_AMOUNT) {
    return FF2Step.MortgageTooSmallRemo;
  }

  const dateToCheck = new Date(formData.dealExpiry!);
  const withinSixMonths = isEndDateLessThanXDays(dateToCheck, 180);

  if (withinSixMonths) {
    nextStep = FF2Step.Signup;
  } else if (formData.additionalBorrowing === AdditionalBorrowing.Yes) {
    if (withinSixMonths) {
      nextStep = FF2Step.Signup;
    } else {
      nextStep = FF2Step.RedirectToSecuredHomepage;
    }
  } else {
    nextStep = FF2Step.EmailToRateTracker;
  }

  return nextStep;
};
